import { render, staticRenderFns } from "./MoleculeForgetPassword.vue?vue&type=template&id=217f701c"
import script from "./MoleculeForgetPassword.vue?vue&type=script&lang=js"
export * from "./MoleculeForgetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports